/**
 * Helpers for multi-provider subscription branching.
 *
 * The backend returns `active_subscription_providers` on /auth/users/me:
 * the list of billing providers where the user holds a live
 * (active / trialing / past_due) subscription.
 *
 * Rule: management/purchase surfaces branch on this list — and only this
 * list. `subscription.provider` is the representative row (possibly a
 * canceled historical one) and must never drive behavior.
 */

export const STRIPE_PROVIDER = "stripe";
export const APP_STORE_PROVIDER = "app_store";

/** Backend error codes that mean "this subscription lives in the App Store". */
export const APP_STORE_SUBSCRIPTION_ERROR_CODES = [
  "payment.app_store_subscription", // customer-portal, 400
  "payment.app_store_subscription_active", // checkout-session, 409
];

export const GENERIC_PAYMENT_ERROR_MESSAGE =
  "Something went wrong. Please try again.";

export const getActiveSubscriptionProviders = (profile) =>
  profile?.active_subscription_providers ?? [];

export const hasActiveAppStoreSubscription = (profile) =>
  getActiveSubscriptionProviders(profile).includes(APP_STORE_PROVIDER);

export const hasActiveStripeSubscription = (profile) =>
  getActiveSubscriptionProviders(profile).includes(STRIPE_PROVIDER);

export const isAppStoreSubscriptionError = (error) =>
  APP_STORE_SUBSCRIPTION_ERROR_CODES.includes(error?.error_code);
